import { createSlice } from "@reduxjs/toolkit";
import { generateTextToSpeachVoice } from "../../../utils/blobHelpers";

const initialState = {
  utils: {
    digits: { text: "", ar: "", en: "" },
    noAnswer: { ar: {}, en: {} },
    noOffers: { ar: {}, en: {} },
    inActive: { ar: {}, en: {} },
    notInUsed: { ar: {}, en: {} },
    pressNo: { ar: {}, en: {} },
    recordComplaint: { ar: {}, en: {} },
    recordSuggestion: { ar: {}, en: {} },
    recordConf: { ar: {}, en: {} },
    complainNum: { ar: {}, en: {} },
    sectionMenu: { ar: {}, en: {} },
    language: { ar: {}, en: {} },
    toSection: { ar: {}, en: {} },
    returnToMain: { ar: {}, en: {} },
    wait: { ar: {}, en: {} },
    welcomeSection: { ar: {}, en: {} },
    quality: { ar: {}, en: {} },
    welcome: { ar: {}, en: {} },
    end: { ar: {}, en: {} },
  },
  status: "idle",
  error: null,
};

const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    setDigits: (state, action) => {
      state.utils.digits = action.payload.digits;
    },

    setNoAnswer: (state, action) => {
      state.utils.noAnswer = action.payload.noAnswer;
    },
    setNoOffers: (state, action) => {
      state.utils.noOffers = action.payload.noOffers;
    },
    setInActive: (state, action) => {
      state.utils.inActive = action.payload.inActive;
    },
    setNotInUsed: (state, action) => {
      state.utils.notInUsed = action.payload.notInUsed;
    },
    setPressNo: (state, action) => {
      state.utils.pressNo = action.payload.pressNo;
    },
    setRecordComplaint: (state, action) => {
      state.utils.recordComplaint = action.payload.recordComplaint;
    },
    setRecordSuggestion: (state, action) => {
      state.utils.recordSuggestion = action.payload.recordSuggestion;
    },
    setRecordConf: (state, action) => {
      state.utils.recordConf = action.payload.recordConf;
    },
    setComplainNum: (state, action) => {
      state.utils.complainNum = action.payload.complainNum;
    },
    setSectionMenu: (state, action) => {
      state.utils.sectionMenu = action.payload.sectionMenu;
    },
    setLanguage: (state, action) => {
      state.utils.language = action.payload.language;
    },
    setToSection: (state, action) => {
      state.utils.toSection = action.payload.toSection;
    },
    setReturnToMain: (state, action) => {
      state.utils.returnToMain = action.payload.returnToMain;
    },
    setWait: (state, action) => {
      state.utils.wait = action.payload.wait;
    },
    setWelcomeSection: (state, action) => {
      state.utils.welcomeSection = action.payload.welcomeSection;
    },
    setQuality: (state, action) => {
      state.utils.quality = action.payload.quality;
    },
    setWelcome: (state, action) => {
      state.utils.welcome = action.payload.welcome;
    },
    setEnd: (state, action) => {
      state.utils.end = action.payload.end;
    },
  },
});

export const {
  setDigits,
  setNoAnswer,
  setNoOffers,
  setInActive,
  setNotInUsed,
  setPressNo,
  setRecordComplaint,
  setRecordSuggestion,
  setRecordConf,
  setComplainNum,
  setSectionMenu,
  setLanguage,
  setToSection,
  setReturnToMain,
  setWait,
  setWelcomeSection,
  setQuality,
  setWelcome,
  setEnd,
} = utilsSlice.actions;
export default utilsSlice.reducer;
